// extracted by mini-css-extract-plugin
export default {"labelWrapper":"labelWrapper---ettGi"};